import { useEffect, useState } from "react";
import type { Session } from "@supabase/supabase-js";
import { getSupabase, supabaseConfigured } from "./supabase";

export interface SessionState {
  loading: boolean;
  session: Session | null;
}

// Tracks the Supabase auth session: reads the persisted session on mount, then
// stays in sync via onAuthStateChange (login, token refresh, sign-out).
export function useSession(): SessionState {
  const [state, setState] = useState<SessionState>({
    loading: true,
    session: null,
  });

  useEffect(() => {
    if (!supabaseConfigured) {
      setState({ loading: false, session: null });
      return;
    }
    const supabase = getSupabase();
    let active = true;

    supabase.auth.getSession().then(({ data }) => {
      if (active) setState({ loading: false, session: data.session });
    });

    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      if (active) setState({ loading: false, session });
    });

    return () => {
      active = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  return state;
}
